import { render, staticRenderFns } from "./DRE.vue?vue&type=template&id=5a429d8c"
import script from "./DRE.vue?vue&type=script&lang=js"
export * from "./DRE.vue?vue&type=script&lang=js"
import style0 from "./DRE.vue?vue&type=style&index=0&id=5a429d8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports